<template>
    <div class="grid__container">
        <div
            v-if="isResponse || isError">
            <QuestionsResponse
                :success="isResponse"
                :title="responseTitle"
                :description="responseDescription" />
        </div>
        <div
            v-else
            class="questions">
            <div class="questions__top">
                <div class="questions__top-title">
                    <h1 v-if="title">
                        {{ title }}
                    </h1>
                </div>
            </div>

            <div
                v-if="questionsRate && questionsRate.items && questionsRate.items.length"
                class="questions__list">
                <form
                    ref="form"
                    @submit.prevent="formSubmit">
                    <QuestionsItem
                        :key="questionsRate.id"
                        :title="questionsRate.title"
                        :name="questionsRate.name"
                        num="1"
                        :main="true"
                        :item-type="questionsRate.type"
                        :list="questionsRate.items"
                        :is-error="errors.quality"
                        :is-other-error="errors.other"
                        @change="setQuality" />

                    <QuestionsItem
                        v-if="questionsLow && questionsLow.items.length && quality && quality <= 7"
                        :key="questionsLow.id"
                        :title="questionsLow.title"
                        :name="questionsLow.name"
                        num="2"
                        :item-type="questionsLow.type"
                        :list="questionsLow.items"
                        :is-error="errors.low"
                        :is-other-error="errors.otherLow"
                        :has-other-field="questionsLow.hasOtherField"
                        @change="(payload) => questionItemChanged(payload, questionsLow.name)" />

                    <QuestionsItem
                        v-if="questionsHigh && questionsHigh.items.length && quality"
                        :key="questionsHigh.id"
                        :title="questionsHigh.title"
                        :name="questionsHigh.name"
                        :num="quality > 7 ? '2' : '3'"
                        :item-type="questionsHigh.type"
                        :list="questionsHigh.items"
                        :is-error="errors.high"
                        :is-other-error="errors.other"
                        :has-other-field="questionsHigh.hasOtherField"
                        @change="(payload) => questionItemChanged(payload, questionsHigh.name)" />
                        
                    <QuestionsItem
                        v-if="questionsComfortable && questionsComfortable.items.length && quality"
                        :key="questionsComfortable.id"
                        :num="quality > 7 ? '3' : '4'"
                        :title="questionsComfortable.title"
                        :name="questionsComfortable.name"
                        :main="false"
                        :item-type="questionsComfortable.type"
                        :list="questionsComfortable.items"
                        :is-error="errors.comfortable"
                        :comfortable-other-placeholder="questionsComfortable.otherText ? 
                            questionsComfortable.otherText :
                            'Открытый комментарий'"
                        :has-other-field="questionsComfortable.hasOtherField"
                        @change="setComfortable" />

                    <STBaseButton
                        type="submit"
                        :disabled="isError"
                        class="questions__button"
                        text="Отправить" />
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import QuestionsItem from '../../blocks/Questions/QuestionsItem/QuestionsItem.vue';
import QuestionsResponse from '../../blocks/Questions/QuestionsResponse/QuestionsResponse.vue';

export default {
    name: 'Questions',

    components: {
        QuestionsItem,
        QuestionsResponse
    },

    data() {
        return {
            isError             : false,  // есть ли ошибка
            isResponse          : false,  // успешная отправка
            responseTitle       : '',     // заголовок ответа
            responseDescription : '',     // описание ответа
            title               : null,   // заголовок
            result              : {},     // результат опроса
            questionsRate       : [],     // список вопросов первой оценки
            questionsLow        : [],     // список вопросов если меньше или равно 7 баллов в первом ответе
            questionsHigh       : [],     // список вопросов если больше или равно 8 баллов в первом ответе
            questionsComfortable: [],     // список вопросов если больше или равно 8 баллов в первом ответе
            quality             : null,   // результат первого ответа - качество обслуживания
            otherText           : '',     // текст в поле "Другое"
            otherLowText        : '',     // текст в поле "Другое" для низкой оценки
            otherComfortableText: '',     // текст в поле "Другое" для удобства
            comfortable         : null,   // результат второго ответа - удобство
            referrer            : null,   // id пользователя из url
            errors              : {
                quality    : false,
                low        : false,
                high       : false,
                comfortable: false,
                other      : false,
                otherLow   : false
            }
        };
    },

    async created() {
        this.getQuestions();

        if (this.$route.query && this.$route.query.user_id) {
            this.referrer = window.location.href;
        }
    },

    methods: {
        ...mapActions(['getQuestionsData', 'sendQuestionsData']),

        async getQuestions() {
            try {
                const response = await this.getQuestionsData();
                
                if (!response) {
                    throw new Error('Не удалось получить данные');
                }

                this.title = response.data.title;
                this.questionsRate = response.data.questions.find(item => item.name === 'questionRate');
                this.questionsLow = response.data.questions.find(item => item.name === 'questionLow');
                this.questionsHigh = response.data.questions.find(item => item.name === 'questionHigh');
                this.questionsComfortable = response.data.questions.find(item => item.name === 'questionComfortable');
            } catch (error) {
                this.showError();
                console.error(error);
            }
        },

        showError() {
            this.isResponse = false;
            this.isError = true;
        },

        setQuality(payload) {
            this.quality = payload.value;
            // Сбрасываем ошибки для всех видов вопросов
            Object.keys(this.errors).forEach((key) => {
                this.errors[key] = false;
            });
        },

        setComfortable(payload) {
            this.comfortable = payload.value;
            this.otherComfortableText = payload.other?.length ? payload.other : '';

            this.errors.comfortable = this.comfortable === null;
        },

        questionItemChanged(payload, name) {
            this.result[name] = payload.value;

            if (name === 'questionHigh') {
                this.otherText = payload.other;
            }

            if (name === 'questionLow') {
                this.otherLowText = payload.other;
            }

            // Сбрасываем ошибки для всех видов вопросов
            Object.keys(this.errors).forEach((key) => {
                this.errors[key] = false;
            });
        },

        formSubmit() {
            // Если качество обслуживания выбрано - проверяем отсавшиеся
            // элементы иначе ставим ошибку
            if (!this.quality) {
                this.errors.quality = true;

                return;
            } else {
                this.errors.low = this.quality <= 7 && !this.result.questionLow?.length ? true : false;
                this.errors.high = !this.result.questionHigh?.length ? true : false;
                this.errors.comfortable = this.comfortable === null;
                this.errors.other = !this.otherText?.length &&
                    this.result.questionHigh?.length &&
                    this.result.questionHigh.includes('other') ? true : false;
                this.errors.otherLow = !this.otherLowText?.length &&
                    this.result.questionLow?.length &&
                    this.result.questionLow.includes('other') ? true : false;
            }

            // Если есть ошибки - выходим (ошибки могут быть только в требуемом
            // списке, из условия выше)
            // if (this.errors.low || this.errors.high || this.errors.other || this.errors.otherLow) {
            //     return;
            // }
            // Если есть ошибки - выходим (ошибки могут быть только в требуемом
            // списке, из условия выше)
            let isFormError = false;

            Object.keys(this.errors).forEach((key) => {
                if (this.errors[key] === true) {
                    isFormError = true;
                }
            });

            if (isFormError) {
                return;
            }

            const computedReason = this.quality <= 7 ?
                this.questionsLow.items
                    .filter(item => this.result.questionLow.includes(item.value))
                    .map(item => item.text).join(', ') :
                '';

            const computedHighReason = this.questionsHigh.items
                .filter(item => this.result.questionHigh.includes(item.value))
                .map(item => item.text).join('; ');

            const resultData = {
                result: {
                    quality             : this.quality,
                    reason              : computedReason,
                    highReason          : computedHighReason,
                    comfortable         : Number(this.comfortable) ? 'Удобно' : 'Неудобно',
                    otherText           : this.otherText,
                    otherLowText        : this.otherLowText,
                    otherComfortableText: this.otherComfortableText
                },
                referrer: this.referrer
            };

            this.sendQuestionsData(resultData)
                .then((response) => {
                    this.responseTitle = response.data.title;
                    this.responseDescription = response.data.description;
                    this.isResponse = true;
                })
                .catch((error) => {
                    console.error(error);
                    this.responseTitle = 'Ой, что-то пошло не так';
                    this.responseDescription = 'Попробуйте заполнить форму позже';
                    this.showError();
                });
        }
    }
};
</script>

<style lang="scss">
@import "./ClientQuestions";
</style>